import React, { useEffect, useState } from 'react'
import Remix from '@/containers/Remix'
// import DownloadWall from '@/features/DownloadWall'

export default function RemixIndex() {
    const [isClient, setIsClient] = useState(false)
    useEffect(() => {
        setIsClient(true)
    }, [])

    return (
        <>
            {isClient && (
                <Remix />
            )}
        </>
    )
}
